// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.salaries {
  box-sizing: border-box;
  display: block;
  padding: 1px 16px 16px 16px;
  margin: 1em 0;
  background: #F7F9FC;
  border-radius: 6px;
  position: relative;
  color: #1E2532;
}

.salary__item {
  padding: 10px 0;
}

.salaries-container {
  display: none;
  width: 100%;
  height: 100%;
  max-height: 232px;
  padding: 8px;
  border-top: 1px solid #e6ebf4;
  overflow-y: auto;

  &.is-visible {
    display: block;
  }
}

.selected-title, .selected {
  padding: 16px;
}

.salaries_selected_salary {
 padding: 9px 0;
}

.selected-salaries .salaries_selected_salary {
  display: inline-block;
  padding: 0 6px;
  border-radius: 10px;
  background-color: #f1f1f1;
  margin: 4px 2px;
}

.selected-salaries .closebtn {
  padding-left: 10px;
  color: #888;
  font-weight: bold;
  float: right;
  font-size: 20px;
  cursor: pointer;
}

.selected-salaries .closebtn:hover {
  color: #000;
}

.salary__item_bar {
  height: 4px;
  flex-shrink: 0;
  border-radius: 4px;
  background: linear-gradient(270deg, #54AFF8 0%, #C3E5FE 100%);
  width: 50%;
}

.salary__item_bar_empty {
  border-radius: 4px;
  background: var(--neutral-neutral-15, #E7EAF4);
  margin-top: 7px;
}

.salary__item_title {
  color: var(--neutral-neutral-90, #1E2532);
  font-family: TT Talent;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 126.316% */
  display: inline-block;
  width: 70%
}

.salary__item_amnt {
  color: var(--neutral-neutral-60-ext, #656E83);
  text-align: right;
  /* Website/XS */
  font-family: TT Talent;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 126.316% */
  display: inline-block;
  text-align: right;
  width: 30%
}

.salary__footer {
  text-align: center;
  padding: 11px 0;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/salaries/styles.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,qBAAqB;EACrB;AACF;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,qBAAqB;EACrB,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["\n.salaries {\n  box-sizing: border-box;\n  display: block;\n  padding: 1px 16px 16px 16px;\n  margin: 1em 0;\n  background: #F7F9FC;\n  border-radius: 6px;\n  position: relative;\n  color: #1E2532;\n}\n\n.salary__item {\n  padding: 10px 0;\n}\n\n.salaries-container {\n  display: none;\n  width: 100%;\n  height: 100%;\n  max-height: 232px;\n  padding: 8px;\n  border-top: 1px solid #e6ebf4;\n  overflow-y: auto;\n\n  &.is-visible {\n    display: block;\n  }\n}\n\n.selected-title, .selected {\n  padding: 16px;\n}\n\n.salaries_selected_salary {\n padding: 9px 0;\n}\n\n.selected-salaries .salaries_selected_salary {\n  display: inline-block;\n  padding: 0 6px;\n  border-radius: 10px;\n  background-color: #f1f1f1;\n  margin: 4px 2px;\n}\n\n.selected-salaries .closebtn {\n  padding-left: 10px;\n  color: #888;\n  font-weight: bold;\n  float: right;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.selected-salaries .closebtn:hover {\n  color: #000;\n}\n\n.salary__item_bar {\n  height: 4px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background: linear-gradient(270deg, #54AFF8 0%, #C3E5FE 100%);\n  width: 50%;\n}\n\n.salary__item_bar_empty {\n  border-radius: 4px;\n  background: var(--neutral-neutral-15, #E7EAF4);\n  margin-top: 7px;\n}\n\n.salary__item_title {\n  color: var(--neutral-neutral-90, #1E2532);\n  font-family: TT Talent;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 126.316% */\n  display: inline-block;\n  width: 70%\n}\n\n.salary__item_amnt {\n  color: var(--neutral-neutral-60-ext, #656E83);\n  text-align: right;\n  /* Website/XS */\n  font-family: TT Talent;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 126.316% */\n  display: inline-block;\n  text-align: right;\n  width: 30%\n}\n\n.salary__footer {\n  text-align: center;\n  padding: 11px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
